import { useEffect, useState } from "react"

import { Flex, Modal, Typography } from "antd"

import Icon from "../../../Icon"
import ButtonComponent from "../../Button"

import "./styles.less"

const { Text, Title } = Typography

const TwoFactorSecretModal = ({ open, onClose, setupKey }) => {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (!isCopied) return undefined

    const timeoutId = setTimeout(() => {
      setIsCopied(false)
    }, 2000)

    return () => clearTimeout(timeoutId)
  }, [isCopied])

  useEffect(() => {
    if (!open) {
      setIsCopied(false)
    }
  }, [open])

  const handleCopy = () => {
    navigator.clipboard.writeText(setupKey)
    setIsCopied(true)
  }

  return (
    <Modal
      open={open}
      centered
      width={460}
      footer={null}
      closable
      onCancel={onClose}
      rootClassName="two-factor-secret-modal"
      classNames={{ content: "clear-bg" }}
    >
      <Title level={4} className="two-factor-secret-title">
        Your two-factor secret
      </Title>

      <Text type="secondary" className="two-factor-secret-description">
        Unable to scan QR code? You can use this setup key to manually configure your authenticator
        app.
      </Text>

      <Flex align="center" justify="center" className="two-factor-secret-key">
        <Text className="two-factor-secret-key-text">{setupKey}</Text>

        <ButtonComponent
          type="text"
          size="small"
          icon={
            isCopied ? (
              <Icon type="check" className="two-factor-secret-copy-success" />
            ) : (
              <Icon type="copy_revert" />
            )
          }
          onClick={handleCopy}
        />
      </Flex>

      <Flex justify="flex-end">
        <ButtonComponent type="primary" onClick={onClose}>
          Done
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}

export default TwoFactorSecretModal
